import {CREATE_INFO } from "./types";

// CREATE MESSAGE
export const createInfo = msg => {
  return {
    type: CREATE_INFO,
    payload: msg
  };
};
